var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', vh + 'px');

(function($){

    var 
        _html,
        _body,
        _window
    ;
    var App = {

        $header  : null,
        $footer : null,
        $menuToggle : null,
        $menu : null,
        $jeitoRio : null,
        $jeitoRioTitle : null,
        $excelencia : null,
        $contato : null,
        lastScrolTop : false,
        timeResize : false,
        currentMouseY : -1,

        init : function(){

            _html = $( 'html' );
            _body = $( 'body' );
            _window = $( window );

            App.$header = _body.children( 'header' ).first();
            App.$footer = $( '#main > footer' ).first();
            App.$menuToggle = $( '.menu-toggle' );
            App.$menu = $( '#menu' ).first();
            App.$bannerHome = $( 'body.home .banner-principal' );
            
            // Jeito Rio
            App.$jeitoRio = $( '.jeito-rio' );

            // Banner excelência (quem somos)
            App.$excelencia = $( '.banner-excelencia' );

            // Contato
            App.$contato = $( '.form-contato' );

            App.bindHeader();
            App.bindSanfonas();
            App.bindContato();

            if( !App.isMobile() ){
                App.bindArrow(); 
            }
            else{
                App.mobileHeights();
            }

            // Bind scroll
            if( App.$jeitoRio.length || App.$excelencia.length ){

                // Jeito Rio title
                if( App.$jeitoRio.length ){
                    App.$jeitoRioTitle = $( 'header h3', App.jeitoRio ).first();
                }

                 _window.scroll(function(){
                    App.checkScroll();
                });
                App.checkScroll();
               
            }

            $( '.main-class-hover' ).hover( 
                function(){
                    this.$ = this.$ || $( this );
                    this.$.parents( '.parent-hover' ).first().addClass( 'hover' )
                },
                function(){
                    this.$ = this.$ || $( this );
                    this.$.parents( '.parent-hover' ).first().removeClass( 'hover' )
                }
            );
            
            // Bind resize
            _window.bind( 'resize', function(){
                if( App.timeResize ) clearTimeout( App.timeResize );
                App.timeResize = setTimeout(function(){
                    scrollTop = _window.scrollTop();
                    App.checkScroll( scrollTop );
                }, 100 );
            }).resize();

        },

        bindContato : function(){

            if( !App.$contato.length ) return true;

            var $trigger = $( 'a.button', App.$contato );
            $trigger.on( 'click', function(e){

                e.preventDefault();
                App.$contato.addClass( 'opened' );

            });

        },

        // Sanfona
        bindSanfonas : function(){

            var $items = $( '.piki-sanfona' );
            if( $items.length ){
                $items.each(function(){

                    this.$ = this.$ || $( this );

                    var style = this.$.data( 'style' );
                    this.$.pikiSanfona({
                        style : style ? style : 'abas'
                    });

                });

            }

        },

        mobileHeights : function(){

            var vHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

            // Menu height
            this.$menu.css({ 'height': vHeight + 'px' });
            this.$menu.css( 'height', ( vHeight * 0.988888 ) + 'px' );

        },

        bindArrow : function(){

            var currentMousePos = { x: -1, y: -1 };
            $( document ).mousemove(function( event ){

                var 
                    vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
                    percent = 30,
                    additional
                ;

                if( event.pageY >= vh ){
                    additional = 70;
                }
                else {
                    additional = ( event.pageY * 100 / vh ) * 0.7;
                }

                percent += additional;

                if( percent > 100 ) percent = 100;

                $( '.arrow span' ).css( 'height', percent + '%' );
                
            });

        },
        
        // Uncheck menu items when is top page
        checkScroll : function(){

            var scrollTop = _window.scrollTop();     
            
            // Jeito Rio title
            if( App.$jeitoRio.length ){
                App.checkJeitoRio( scrollTop );
            }
            if( App.$excelencia.length ){
                App.checkExcelencia( scrollTop );
            }
        
        },

        checkExcelencia : function( scrollTop ){
            
            if( !App.$excelencia.hasClass( 'animated' ) ){

                var bannTop =  App.$excelencia.offset().top;
                if( scrollTop >= ( bannTop - 300 ) ){
                    App.$excelencia.addClass( 'animated' );
                }
            
            }

        },

        checkJeitoRio : function( scrollTop ){

            var 
                jeitoTop = App.$jeitoRio.offset().top,
                jeitoBottom = jeitoTop + App.$jeitoRio.innerHeight() - parseInt( App.$jeitoRio.css( 'padding-bottom' ) ),
                jeitoTitleHeight = App.$jeitoRioTitle.outerHeight()
            ;

            if( scrollTop >= jeitoTop ){

                App.$jeitoRio.addClass( 'sticked' );

                if( scrollTop >= ( jeitoBottom - jeitoTitleHeight - 44 ) ){
                    App.$jeitoRio.addClass( 'at-bottom' );
                }
                else {
                    App.$jeitoRio.removeClass( 'at-bottom' );
                }
            
            }
            else {
                App.$jeitoRio.removeClass( 'sticked at-bottom' );
            }

        },

        // Binding header
        bindHeader : function(){
            // Menu toggle
            App.$menuToggle.on( 'click', function(e){
                App.toggleMenu();
            });
            // Close menu
            $( 'button', App.$menu ).on( 'click', function(){
                App.closeMenu();
            });
            $( 'a', App.$menu ).on( 'click', function(){
                App.closeMenu();
            });
        },

        // Toggle mobile menu
        toggleMenu : function(){
            if( _body.hasClass( 'menu-opened' ) ){
                App.closeMenu();
            }
            else {
                App.openMenu();
            }
        },

        // Open menu mobile
        openMenu : function(){

            App.lockScroll();
            
            App.$menuToggle.addClass( 'opened' );
            _body.addClass( 'menu-opened' );
        
        },

        // Close menu mobile
        closeMenu : function(){
        
            App.$menuToggle.removeClass( 'opened' );
            _body.removeClass( 'menu-opened' );

            App.unlockScroll();
        
        },

        lockScroll : function(){
            _html.addClass( 'lockscroll' );
            _body.addClass( 'lockscroll' );
        },

        unlockScroll : function(){
            _html.removeClass( 'lockscroll' );
            _body.removeClass( 'lockscroll' );
        },

        scrollTo : function( selector ){

            var $target = typeof( selector ) === 'object' ? selector : $( selector );            
            if( !$target.length ) return;

            var newY = $target.offset().top;
            var actualY = _window.scrollTop();
            var distance = actualY - newY;
            if( distance < 0 ) distance *= -1;

            var time = ( 600 - ( distance * 0.1 ) );
            if( time < 600 ) time = 600;
            
            var offset = $target.data( 'offset' );
            if( offset ){

                try {

                    var 
                        _json = JSON.parse( offset.split( "'" ).join( '"' ) )
                        _offset = false,
                        _vWidth = App.vWidth()
                    ;

                    $.each( _json.breaks, function( _break ){
                        if( _vWidth <= _break ){
                            _offset = parseInt( this );
                            return false;
                        }
                    });

                    offset = ( !_offset ) ? parseInt( _json.initial ) : _offset;

                }
                catch( e ){
                    var _offset = parseInt( offset );
                    offset = _offset > 0 ? _offset : 0;
                }

            }
            else {
                offset = 0;
            }

            $( 'html, body' ).animate({
                scrollTop: ( newY - ( offset + 30 ) )
            }, time );      

        },

        vWidth : function vWidth(){
            return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        },

        isMobile : function(){
            return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
        }

    };
    $(function(){       
        App.init();
    });

})(jQuery);
